import React from 'react'
import { Box } from '@mui/material'

/**
 * Compact state pill used in listing tables, so a column of statuses can be
 * scanned by colour. Covers order states and withdrawal states; anything not
 * listed falls back to a neutral grey rather than going unstyled.
 */
const TONES = {
  // In progress
  PENDING: { bg: '#FEF3C7', fg: '#92400E' },
  REQUESTED: { bg: '#FEF3C7', fg: '#92400E' },
  ACCEPTED: { bg: '#DBEAFE', fg: '#1D4ED8' },
  ASSIGNED: { bg: '#DBEAFE', fg: '#1D4ED8' },
  PICKED: { bg: '#EDE9FE', fg: '#6D28D9' },
  // Settled
  DELIVERED: { bg: '#DCFCE7', fg: '#15803D' },
  TRANSFERRED: { bg: '#DCFCE7', fg: '#15803D' },
  // Stopped
  CANCELLED: { bg: '#FEE2E2', fg: '#B91C1C' }
}

const StatusBadge = ({ status }) => {
  const tone = TONES[status] || { bg: '#F1F3F7', fg: '#4B5563' }
  return (
    <Box
      component="span"
      sx={{
        // A table cell lays its content out as a centred flex row, so the badge
        // must not pin itself to the top with an alignSelf of its own.
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: 0.25,
        borderRadius: '999px',
        backgroundColor: tone.bg,
        color: tone.fg,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap'
      }}>
      {status}
    </Box>
  )
}

export default StatusBadge
